<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing && registro.csTipoAdm != 'RC'" @delete="beforeDeleteRegistro" :canAdd="false"
        :isSearch="true" :canSearch="false">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Administração de Medicamento</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6 v-if="registro.csTipoAdm != 'RC'">
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFutura]" label="Início do Tratamento" v-model="dataInicioTratamento"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md6 lg6 v-else>
                    <v-text-field v-model="dataInicioTratamento" label="Início do Tratamento" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 v-if="registro.csTipoAdm != 'RC'">
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFuturaTrintaDias]" label="Fim do Tratamento" v-model="dataFimTratamento"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 v-else>
                    <v-text-field v-model="dataFimTratamento" label="Fim do Tratamento" filled disabled>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6 v-if="registro.csTipoAdm != 'RC'">
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.csTipoAdm" :items="listaTipoAdm" clearable
                        color="primary" item-text="dsTipo" item-value="stTipo" label="Via de Aplicação" outlined>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md6 lg6 v-else>
                    <v-text-field v-model="descricaoRacao" label="Via de Aplicação" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 v-if="registro.csTipoAdm != 'RC'">
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdFarmaco" :items="farmacos" clearable @change="changeFarmaco"
                        color="primary" item-text="nmNome" item-value="idFarmaco" label="Selecione o medicamento por nome" outlined>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 v-else>
                    <v-text-field v-model="registro.farmaco.nmNome" label="Selecione o medicamento por nome" filled disabled>
                    </v-text-field>
                </v-flex>
<!-- AQUIIII                -->
                <v-flex class="item" xs11 md11 lg11 v-if="registro.csTipoAdm == 'RC'">
                    <v-autocomplete v-model="registro.lstCdSinaisClinicos" :items="lstSinalClinico" disabled filled
                                color="primary" chips multiple small-chips
                                item-text="nmSinalClinico" item-value="idSinalClinico"
                                :rules="[ruleSinaisClinicosConformeTipo]"
                                label="Selecione os sinais clínicos relacionados">
                         <template v-slot:selection="{ attrs, item, selected }">
                              <v-chip  v-bind="attrs" close :input-value="selected" color="grey lighten-3"
                                       class="teste"
                                       @click:close="removeSinalClinico(item)" close-icon="$delete">
                                  {{ item.nmSinalClinico }}
                              </v-chip>
                         </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md11 lg11 v-else>
                    <v-autocomplete v-model="registro.lstCdSinaisClinicos" :items="lstSinalClinico" clearable
                                color="primary" outlined chips multiple small-chips
                                item-text="nmSinalClinico" item-value="idSinalClinico"
                                :rules="[campoSelectObrigatorio]"
                                label="Selecione os sinais clínicos relacionados">
                         <template v-slot:selection="{ attrs, item, selected }">
                              <v-chip  v-bind="attrs" close :input-value="selected" color="grey lighten-3"
                                       class="teste"
                                       @click:close="removeSinalClinico(item)" close-icon="$delete">
                                  {{ item.nmSinalClinico }}
                              </v-chip>
                         </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="registro.csTipoAdm != 'RC'">
                <v-flex class="item" xs11 md4 lg3>
                    <v-text-field :rules="rulesQtAnimais" v-model.trim="registro.qtAnimaisMedicados" label="Qtd Animais Medicados" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md4 lg3>
                    <v-text-field :rules="[campoMaiorOuIgualZero]" type="number" v-model.number="registro.nrPeso" label="Peso (kg)" outlined @change="calculaDosagem">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-if="registro.csTipoAdm == 'IJ'">
                    <v-text-field v-model.trim="registro.nrDosagem" label="Dosagem" filled disabled :suffix="suffixDosagem">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-else>
                    <v-text-field v-model.trim="registro.nrDosagem" label="Dosagem" outlined clearable :suffix="suffixDosagem">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md0 lg2>
                    <v-spacer/>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-else>
                <v-flex class="item" xs11 md4 lg3>
                    <v-text-field v-model.trim="registro.qtAnimaisMedicados" label="Qtd Animais Medicados" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md9 lg8>
                    <v-spacer/>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11 v-if="registro.csTipoAdm != 'RC'">
                    <v-text-field v-model.trim="registro.dsObservacao" label="Observações" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md11 lg11 v-else>
                    <v-text-field v-model.trim="registro.dsObservacao" label="Observações" filled disabled>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm :canSave="registro.csTipoAdm != 'RC'" @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarDataFutura, validarDataFuturaTrintaDias, campoMaiorOuIgualZero } from '@/filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'

export default {
    name: 'AdmFarmaco',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: { lstCdSinaisClinicos: [] },
            isLoading: false,
            cdLoteProducao: 0,
            suffixDosagem: '',
            dataInicioTratamento: '',
            dataFimTratamento: '',
            descricaoRacao: 'Ração',
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Administração de Medicamento: ' + this.registro.idAdmFarmaco

                return 'Inserindo nova Administração de Medicamento'
            }
        },
        farmacos () {
            if (this.registro.csTipoAdm != undefined)
            {
                return this.$store.state.farmacos.filter(entry => {return entry.csTipoAdm == this.registro.csTipoAdm})
            }
            else
            {
                return []
            }
        },
        lstSinalClinico() {
          if (!this.$store.state.lstSinalClinico) return []
            return this.$store.state.lstSinalClinico.sort(function(a, b){
                if(a.nmSinalClinico < b.nmSinalClinico) { return -1; }
                if(a.nmSinalClinico > b.nmSinalClinico) { return 1; }
                return 0;
            });
        },
        rulesQtAnimais () {
            if (this.registro.csTipoAdm == 'IJ')
            {
                return [campoObrigatorio]
            }
            return []
        },
        ruleSinaisClinicosConformeTipo () {
            if (this.registro.cdFarmaco != undefined) {
                var farmaco = this.farmacos.find(x => x.idFarmaco == this.registro.cdFarmaco)
                if (farmaco != undefined) {
                    if (!farmaco.flVacina) {
                        return [campoSelectObrigatorio]
                    }
                }
                if (this.registro.csTipoAdm != 'RC') {
                    return [campoSelectObrigatorio]
                }
            }
            return []
        },
        listaTipoAdm() {
        	return this.$store.state.tiposAdmFarmaco
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData, 
        validarDataFutura, 
        validarDataFuturaTrintaDias,
        dateLocalToIso,
        dateIsoToLocal,
        campoMaiorOuIgualZero,
        calculaDosagem () {
            var farmaco = this.farmacos.find(i => i.idFarmaco === this.registro.cdFarmaco )

            if (farmaco.flDoseFixa)
            {
                this.registro.nrDosagem = farmaco.nrDosePorQuilo
            }
            else
            {
                if (this.registro.nrPeso)
                {
                    this.registro.nrDosagem = (Math.round((this.registro.nrPeso * farmaco.nrDosePorQuilo) * 2)) / 2
                }
                else
                {
                    this.registro.nrDosagem = 0
                }
            }
        },
        changeFarmaco (value) {
            if (value && this.farmacos)
            {
                this.registro.nrDosagem = 0
                var farmaco = this.farmacos.find(i => i.idFarmaco === value )
                this.suffixDosagem = farmaco != undefined ? farmaco.csUnidadeMedidaDosagem : ''
                if (farmaco.csTipoAdm == 'IJ')
                {
                    if (farmaco.flDoseFixa)
                    {
                        this.registro.nrDosagem = farmaco.nrDosePorQuilo
                    }
                    else
                    {
                        this.calculaDosagem()
                    }
                }
            }
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadFarmacos')
            this.$store.dispatch('actLoadSinalClinico')
            this.cdLoteProducao = parseInt(route.params.idLote)
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('adm-farmaco/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.suffixDosagem = response.data[0].data.farmaco.csUnidadeMedidaDosagem
                rec.lstCdSinaisClinicos = rec.sinaisClinicos ? rec.sinaisClinicos.map(v => v.idSinalClinico) : [];
                if (rec.sinaisClinicos) rec.sinaisClinicos = null;
                this.registro = Object.assign({}, rec)
                this.dataInicioTratamento = this.dateIsoToLocal(rec.dtInicioTratamento)
                this.dataFimTratamento = this.dateIsoToLocal(rec.dtFimTratamento)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.dtInicioTratamento = this.dateLocalToIso(this.dataInicioTratamento)
            this.registro.dtFimTratamento = this.dateLocalToIso(this.dataFimTratamento)
            this.$axios.post('adm-farmaco/', this.registro)
            .then(() => {
                this.$router.go(-1)
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.dtInicioTratamento = this.dateLocalToIso(this.dataInicioTratamento)
            this.registro.dtFimTratamento = this.dateLocalToIso(this.dataFimTratamento)
            this.$axios.put('adm-farmaco/' + this.registro.idAdmFarmaco, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('adm-farmaco/' + this.registro.idAdmFarmaco)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idAdmFarmaco: '',
                dtInicioTratamento: null,
                dtFimTratamento: null,
                csTipoAdm: '',
                nrDosagem: 0,
                nrPeso: 0,
                qtAnimaisMedicados: null,
                stLoteFabricaFarmaco: '',
                dsObservacao: '',
                cdFarmaco: null,
                cdLoteProducao: this.cdLoteProducao,
                flRastreado: false
            }
        },
        removeSinalClinico(item) {
            this.registro.lstCdSinaisClinicos.splice(this.registro.lstCdSinaisClinicos.indexOf(item), 1)
            this.registro.lstCdSinaisClinicos = [...this.registro.lstCdSinaisClinicos]
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
    .v-chip {
        color: dimgray;
    }
</style>
